/**
 * @class
 */
const Layout = Class(
	/**
	 * @lends {Layout#}
	 */
	{
		__NAME: 'Layout',

		hideFooter: false,

		__construct: function () {
			this.node = mkE({
				tag: 'main',
				id: 'container',
			});
		},

		ct: function () {
			if( !this.ctNode ){
				this.ctNode = mkE({
					tag: 'div',
					id: 'ct'
				}).append(this.node);
			}
			return this.ctNode;
		},

		show: function () {
			D.removeLoadingOverlay(this.node);
			let node = document.getElementById('container');
			if (node !== this.node) {
				D.insertBefore(this.node, node);
				removeNode(node);
			}
			if (!D.APP_WEBVIEW && !this.hideFooter) {
				this.footer = T.Footer.get();
				if (!this.footer.parentNode) {
					D.insertAfter(this.footer.node, this.node);
				}
			}
		},

		getCurrent: function () {
			this.node = document.getElementById('container');
			this.ctNode = document.getElementById('ct');
		}
	}
);